import { supabase } from '@/lib/supabase'

export type AnalysisCourtesyStatus = {
  courtesyLimit: number | null
  courtesyUsed: number
  courtesyRemaining: number | null
  courtesyUnlimited: boolean
}

export async function fetchAnalysisCourtesyStatus(): Promise<AnalysisCourtesyStatus> {
  const { data, error } = await supabase.rpc('user_analysis_courtesy_status' as any)

  if (error) {
    throw error
  }

  const row = Array.isArray(data) ? data[0] : data
  if (!row) {
    return {
      courtesyLimit: 0,
      courtesyUsed: 0,
      courtesyRemaining: 0,
      courtesyUnlimited: false,
    }
  }

  const unlimited = Boolean(row?.courtesy_unlimited)
  const used = row?.courtesy_used != null ? Number(row.courtesy_used) : 0

  if (unlimited) {
    return {
      courtesyLimit: null,
      courtesyUsed: used,
      courtesyRemaining: null,
      courtesyUnlimited: true,
    }
  }

  const limit = row?.courtesy_limit != null ? Number(row.courtesy_limit) : 0
  const remaining =
    row?.courtesy_remaining != null ? Number(row.courtesy_remaining) : Math.max(limit - used, 0)

  return {
    courtesyLimit: Number.isFinite(limit) ? limit : 0,
    courtesyUsed: Number.isFinite(used) ? used : 0,
    courtesyRemaining: Number.isFinite(remaining) ? remaining : 0,
    courtesyUnlimited: false,
  }
}
